<template>
  <div>
    <!-- кнопка открытия диалога категорий-->
    <div @click="openFacet('categories')" class="sm-facet_tile">
      <div class="sm-facet__title">Категории</div>
      <div class="sm-facet__chosen">{{ selected_category_name }}</div>
      <svg width="9" height="16" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg" class="sm-facet_tile__icon"><use xlink:href="#chevron-right"></use></svg>
    </div>

    <!-- Диалог выбора категории-->
    <facet-dialog-category facetname="categories" :selected_category_id="selected_category_id_local"></facet-dialog-category>

  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import FacetDialogCategory from "./facet-dialog-category.vue";

export default {
name: "facet-categories-mobile",
  data: function () {
    return {
      selected_category_id_local: 0
    };
  },
  computed: {
    ...mapGetters("search", [
      "selected_category",
      "selected_category_name",
      "categoryFacets",
      "currentOpenFacet"]),
    categories: function () {
      return this.categoryFacets;
    },
    selectedCategoryInfo: function () {
      let selected = this.selected_category_id_local;
      return this.categories.filter(function (item) {
        return item.id === selected;
      })
    }
  },
  methods: {
    ...mapActions("search", [
        "setCurrentOpenFacet"
    ]),
    openFacet(facetname) {
      this.setCurrentOpenFacet(facetname)
    },
    closeFacet() {
      this.setCurrentOpenFacet('')
    }
  },
  components: {
    FacetDialogCategory
  },
  created() {
    this.selected_category_id_local = this.selected_category;
  }
}
</script>